import * as React from 'react'

import { useMUpdateCartItem } from '~graphql/generated/clientGraphql'

import { TCartItem } from '../types'

type TUpdateCartItemsOptions = { cartItems: RoA<TCartItem> }

/**
 * Hook for updating multiple cart items that uses the MUpdateCartItem mutation.
 */
export const useUpdateCartItems = () => {
  const [mUpdateCartItem, updateResult] = useMUpdateCartItem()

  /**
   * Updates multiple cart items.
   */
  const updateCartItems = React.useCallback(
    ({ cartItems }: TUpdateCartItemsOptions) => {
      cartItems.forEach((cartItem) => {
        mUpdateCartItem({
          variables: {
            itemId: cartItem.id,
            note: cartItem.note,
            addons: cartItem.addons,
          },
        })
      })
    },
    [mUpdateCartItem],
  )

  return { updateCartItems, updateResult }
}
